import React from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";

const HelmetApp = () => {
  const currentActivity = useSelector((state) => state.activity);
  const { siteTitle, siteDescription, theme } = currentActivity.websiteData
    .config.data
    ? currentActivity.websiteData.config.data
    : {};
  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="Description" content={siteDescription} />
      <link rel="shortcut icon" href={currentActivity.logo} />
      <link
        rel="stylesheet"
        href={`${process.env.PUBLIC_URL}/assets/css/theme-${theme}.css?ver=131`}
      />
      <style type="text/css">
        {` 
          .pwg-section:nth-child(even) {
          background: white !important;
          }
          .pwg-section:nth-child(even) h2{
          color: black !important;
          }
          .pwg-section:nth-child(even) p{
          color: black !important;
          }
          .pwg-section:nth-child(even) span{
          color: black !important;
          }
        `}
      </style>
    </Helmet>
  );
};
export default HelmetApp;
